import React, { useEffect, useRef, useState } from "react";
import { Menu, Switch, Divider } from "@ezviz/ezd";
import { useHistory, useParams } from "react-router-dom";
import "./index.less";

import { Result, Button } from "@ezviz/ezd";
import DocContent from "../DocContent";

import { SearchBox } from "../Search/index";

const SliderMenu = (props) => {
  let { id } = useParams();
  const history = useHistory();
  // 上方菜单
  const [menuData, setMenuData] = useState([]);
  // 左侧菜单
  const [thData, setThData] = useState([]);

  const [showThData, setShowThData] = useState([]);
  // 当前id
  const [activeId, setActiveId] = useState(null);
  // 高亮数组
  const [activeArr, setActiveArr] = useState([]);

  const [BreadData, setBreadData] = useState([]);

  /* 前端缓存菜单 开始 **/
  const _map = (data, ids) => {
    return data.map((i) => {
      if (ids.includes(i.id.toString())) {
        if (i.children && ids[ids.length - 1] != i.id) {
          i.children = _map(i.children, ids);
        }
        return i;
      } else {
        if (i.children) {
          return { ...i, children: [] };
        }
        return i;
      }
    });
  };

  useEffect(() => {
    let data = JSON.parse(JSON.stringify(thData));
    let arr = _map(data, activeArr);
    setShowThData(arr);
  }, [thData, activeArr]);
  /* 前端缓存菜单 结束 **/

  useEffect(() => {
    let data = JSON.parse(props.data);
    props.activeId && setActiveId(props.activeId);
    setMenuData(data);
    changeMenu(data, activeId);
  }, [props.data]);

  const changeMenu = (menuData = [], activeId) => {
    if (menuData && menuData.length > 0) {
      if (!activeId) {
        // 强制转 1798 公共文章页面
        // window.location.href = "/help/356" + window.location.search;
        history.push("/help/1798" + window.location.search);
        // setThData(menuData[1].children);
        // setActiveArr([
        //   menuData[1].id,
        //   "4328980346db4cb5a71529fa3ba5a011",
        //   "1798",
        // ]);
        return;
      }
      let str = getMenuString(menuData, activeId);

      if (!str) {
        // message.info("文章没有找到");
        // setTimeout(() => {
        //   window.location.href = "/help/356" + window.location.search;
        // }, 200);
        // 不能随意提示 不能随意跳转 还有文章在接口中找到了 但是没有开放入口

        setThData(menuData[0].children);
        setActiveArr([menuData[0].id]);
        return;
      }

      let _a = getMenumbx(menuData, activeId);
      setBreadData(_a);

      str = str.slice(1);
      let arr = str.split(",");
      let id = arr[0] || "";
      if (id) {
        let item = menuData.find((item) => item.id == id);
        item && setThData(item.children);
      }
      setActiveArr(arr);
    }
  };

  useEffect(() => {
    //   这边可以监听到页面上触发的 参数变更
    try {
      menuData && changeMenu(menuData, id);
    } catch (error) {}
  }, [id]);

  // 深度遍历 是最优解 方便拿到上级路径的参数
  const getMenuString = (data, id, str = "") => {
    // 第一层就是数组
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      if (item.id == id) {
        // 出口在递归之前  删除第一个字符 中线
        return str + "," + item.id;
      }
      if ((item.children && item.children.length) > 0) {
        let res = getMenuString(item.children, id, str + "," + item.id);
        // 找到了再return  没有找到继续遍历最外层
        if (res) {
          return res;
        }
      }
    }
  };

  const getMenumbx = (data, id, arr = []) => {
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      if (item.id == id) {
        return [...arr, { text: item.title, docId: item.id }];
      }
      if ((item.children && item.children.length) > 0) {
        let res = getMenumbx(item.children, id, [
          ...arr,
          { text: item.title, docId: item.id },
        ]);
        if (res) {
          return res;
        }
      }
    }
  };

  const getMenuStringByUUID = (data, id, str = "") => {
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      if (item.id == id) {
        return {
          str: str + "," + item.id,
          id: item.id || "",
        };
      }
      if ((item.children && item.children.length) > 0) {
        let res = getMenuStringByUUID(item.children, id, str + "," + item.id);
        if (res) {
          return res;
        }
      }
    }
  };

  const menuClick = (key) => {
    let { str, id } = getMenuStringByUUID(menuData, key);
    str = str.slice(1);
    let arr = str.split(",");
    if (id && id.length != 32) {
      history.push("/help/" + id);
      // window.location.href = "/help/" + id;
    }
    if (arr.length == 1 && arr[0] != "356") {
      let _m = menuData.find((item) => item.id == key);
      _m && setThData(_m.children);
      _m && getFristDoc(_m.children);
    }
    // 删除key
    if (
      key.length == 32 &&
      activeArr.includes(key) &&
      activeArr.length != 1 &&
      arr.length != 1
    ) {
      let index = arr.findIndex((i) => i == key);
      arr = activeArr.slice(0, index);
    }

    setActiveArr(arr);
  };

  const getFristDoc = (data) => {
    for (let index = 0; index < data.length; index++) {
      if (data[index].id.length == 32) {
        if (data[index].children && data[index].children.length > 0) {
          getFristDoc(data[index].children);
          break;
        }
      } else {
        history.push("/help/" + data[index].id);
        break;
      }
    }
  };

  const getMenu = (data, level) => {
    // 不兼容五级以上的菜单 后期兼容放开即可   Math.min(5, level + 1) 5级后的菜单样式一致不变
    if (level > 5) return null;

    if (data.children) {
      return (
        <Menu.SubMenu
          key={data.id}
          className={["level" + level].join(" ")}
          title={data.title}
          onTitleClick={(e) => {
            menuClick(e.key);
          }}
        >
          {data.children.map((item) => getMenu(item, Math.min(5, level + 1)))}
        </Menu.SubMenu>
      );
    }
    return (
      <Menu.Item key={data.id} className={["level" + level].join(" ")}>
        <span>{data.title}</span>
      </Menu.Item>
    );
  };

  useEffect(() => {
    let scrollHandler = function () {
      let el = document.getElementById("main-section");
      let eld = document.getElementById("main-nav");
      if (el) {
        //  防抖在设置定位属性上效果不好   添加判断是否需要修改定位属性  减少 dom 样式操作
        if (
          el.getBoundingClientRect().top <= 0 &&
          eld.style.position != "fixed"
        ) {
          eld.style.position = "fixed";
        }
        if (
          el.getBoundingClientRect().top > 0 &&
          eld.style.position != "relative"
        ) {
          eld.style.position = "relative";
        }
      }
    };
    scrollHandler();
    window.addEventListener("scroll", scrollHandler, true);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  const [scrollType, setScrollType] = useState("");
  const [scrolling, setScrolling] = useState(false);

  function resize() {
    let type = scrollTypeCheck();
    setScrollType(type);
  }

  useEffect(() => {
    window.addEventListener("resize", resize);

    // setTimeout(() => {
    resize();
    // }, 200);

    return () => {
      window.removeEventListener("resize", resize);
    };
  });

  function scrollTypeCheck() {
    let scrollType = "";
    const NavItemsContianerDom = document.getElementById("nav_ul");
    const commonMenuScrollBarDom = document.getElementById("nav");
    const NavItemsContianerMarginLeft =
      parseInt(NavItemsContianerDom.style.marginLeft) || 0;
    const commonMenuScrollBarWidth =
      parseInt(commonMenuScrollBarDom.clientWidth) || 0;
    const NavItemsContianerWidth =
      parseInt(NavItemsContianerDom.scrollWidth) || 0;
    // console.log('NavItemsContianerWidth', NavItemsContianerWidth)
    // console.log('NavItemsContianerMarginLeft', NavItemsContianerMarginLeft)
    // console.log('commonMenuScrollBarWidth', commonMenuScrollBarWidth)

    if (NavItemsContianerWidth > commonMenuScrollBarWidth) {
      if (NavItemsContianerMarginLeft >= 0) {
        // 说明是在最左边
        scrollType = "scrollRight";
      } else {
        if (
          NavItemsContianerWidth + NavItemsContianerMarginLeft <=
          commonMenuScrollBarWidth
        ) {
          // 说明是在最右边
          scrollType = "scrollLeft";
        } else {
          scrollType = "scrollAll";
        }
      }
    } else {
      scrollType = "";
    }
    console.log("scrollType++++++++++++", scrollType);
    return scrollType;
  }

  const menuScroll = (type) => {
    const NavItemsContianerDom = document.getElementById("nav_ul");
    const commonMenuScrollBarDom = document.getElementById("nav");
    const NavItemsContianerMarginLeft =
      parseInt(NavItemsContianerDom.style.marginLeft) || 0;
    const commonMenuScrollBarWidth =
      parseInt(commonMenuScrollBarDom.clientWidth) || 0;
    if (type == "left") {
      NavItemsContianerDom.style.marginLeft = `${0}px`;
    }
    if (type == "right") {
      NavItemsContianerDom.style.marginLeft = `${
        NavItemsContianerMarginLeft - commonMenuScrollBarWidth
      }px`;
    }

    // 导航滚动动画时间500ms完成后再判断滚动条状态
    setTimeout(() => {
      const scrollType = scrollTypeCheck();
      setScrollType(scrollType);
      setScrolling(false);
    }, 550);
  };

  return (
    <section className="mian-section" id="mian-section">
      <div className="main-nav" id="main-nav">
        <nav className={`${scrollType}`} id="navmain">
          <div
            className="scroll-left-arrow"
            onClick={() => {
              if (!scrolling) {
                menuScroll("left");
                setScrolling(true);
              }
            }}
          ></div>
          <div id="nav">
            <div id="ul">
              <ul id="nav_ul">
                {menuData &&
                  menuData.map((item) => {
                    return (
                      <li
                        className={
                          activeArr.includes(item.id.toString()) ? "active" : ""
                        }
                        onClick={() => {
                          menuClick(item.id);
                          window.scrollTo({ top: 0, behavior: "instant" });
                        }}
                      >
                        {item.id == "12fd1a7c654e45d583b4ee2dda25bdcf" && (
                          <span className="icon icon_api"></span>
                        )}
                        {item.id == "6ac1c6cf4c7c4c819072a10341e74aec" && (
                          <span className="icon icon_sdk"></span>
                        )}
                        {item.title}
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>

          <div
            className="scroll-right-arrow"
            onClick={() => {
              if (!scrolling) {
                menuScroll("right");
                setScrolling(true);
              }
            }}
          ></div>
        </nav>
        <div className="search">
          <SearchBox />
        </div>
      </div>
      <div className="main">
        <div className="nav" style={{ width: "300px" }}>
          <div id="left-nav" style={{ width: "296px" }}>
            <Menu
              style={{ width: 296 }}
              openKeys={activeArr}
              selectedKeys={activeArr}
              mode={"inline"}
              onClick={(e) => {
                menuClick(e.key);
                e.key.length != 32 &&
                  window.scrollTo({ top: 0, behavior: "instant" });
              }}
              triggerSubMenuAction="click"
            >
              {showThData && showThData.map((item) => getMenu(item, 2))}
            </Menu>
          </div>
        </div>
        <div className="doc" style={{ width: "100%" }}>
          {props.htmlContent ? (
            <DocContent htmlString={props.htmlContent} BreadData={BreadData} />
          ) : (
            <Result
              status="404"
              title="404"
              subTitle="没有搜索到相关内容"
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    history.push("/help/356");
                  }}
                >
                  去首页
                </Button>
              }
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default SliderMenu;
